import React, { useState, useEffect, useContext } from "react";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import "moment/locale/pt-br";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import DescriptionIcon from "@mui/icons-material/Description";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DeleteIcon from "@mui/icons-material/Delete";
import blogFetch from "../../axios/config";
import { Add } from "@mui/icons-material";
import {
  TextField,
  Button,
  Paper,
  IconButton,
  List,
  ListItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import Context from "../../context/Context";
import language from "../../nls/language.json";
import './PackingList.css';

export default function PackingList() {
  const [order, setOrder] = useState();
  const [Box, setBox] = useState("");
  const [selectedBox, setSelectedBox] = useState({});
  const [invoice, setInvoices] = useState([]);
  const [selectedItens, setSelectedItens] = useState([]);
  const [hasContent, setHasContent] = useState(false);
  const [hasSelectedContent, setHasSelectedContent] = useState(false);
  const [boxList, setBoxList] = useState([]);
  const [selectedBoxList, setSelectedBoxList] = useState([]);
  const navigate = useNavigate();

  const {
    getStatusSideBar,
    selectedCountry
  } = useContext(Context);

  useEffect(() => {
    getPackingListBox();
  }, []);

  useEffect(() => {
    setHasContent(invoice.length > 0);
  }, [invoice]);

  useEffect(() => {
    setHasSelectedContent(selectedItens.length > 0);
  }, [selectedItens]);

  const getOrder = async () => {
    try {
      let response = await blogFetch.get("/IntercompanyDelevery/" + order);
      let data = response.data;
      data.forEach((obj) => {
        obj.idBox = null;
        obj.boxDescription = null;
      });
      setInvoices(data);
      setSelectedItens([]);
      if (data.length === 0) {
        alert("Documento já gerado");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getPackingListBox = async () => {
    try {
      let response = await blogFetch.get("/PackingListBox");
      let data = response.data;
      setBox(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleChangeBox = (event) => {
    setSelectedBox(event.target.value);
  };

  const sendOrders = async () => {
    try {
      let orders = [];
      for (let i = 0; i < selectedItens.length; i++) {
        let data = {
          PKI_PK_idItem: 0,
          PKI_Pedido: selectedItens[i].packing,
          PKI_Item: selectedItens[i].posicaoPedVenda,
          PKI_FK_PackingListID: null,
          _Creat: "DEV",
          PKI_FK_idBox: selectedItens[i].idBox,
          PKI_BoxNumber: selectedItens[i].boxCode,
        };
        orders.push(data);
      }

      let response = await blogFetch.post("/Invoice/lote_", orders);
      let data = response.data;
      setSelectedItens([]);
      setInvoices([]);
      navigate("/invoice/" + data.pcK_PK_idPackingList);
    } catch (error) {
      console.error(error);
    }
  };

  const addBox = () => {
    const maxBoxId = boxList.reduce(
      (maxId, box) => Math.max(maxId, box.boxId),
      0
    );

    const newBox = {
      boxId: maxBoxId + 1,
      boxDescription: selectedBox.pkB_BoxDescription,
    };
    const newBoxList = [...boxList, newBox];

    setBoxList(newBoxList);
    setSelectedBoxList(newBox);
  };

  const removeBox = (boxToRemove) => {
    const updatedBoxList = boxList.filter((box) => box !== boxToRemove);
    const itemsToRemove = selectedItens.filter(
      (item) => item.boxCode === boxToRemove.boxId
    );
    const remainingItems = selectedItens.filter(
      (item) => item.boxCode !== boxToRemove.boxId
    );

    setInvoices([...invoice, ...itemsToRemove]);
    setSelectedItens(remainingItems);
    setBoxList(updatedBoxList);
    setSelectedBoxList({});
  };

  const handleAddItem = (value) => {
    value.idBox = selectedBox.pkB_PK_idBox;
    value.boxDescription = selectedBoxList.boxDescription;
    value.boxCode = selectedBoxList.boxId;

    setSelectedItens([...selectedItens, value]);
    setInvoices(
      invoice.filter((item) => item.posicaoPedVenda !== value.posicaoPedVenda)
    );
  };

  const handleRemoveItem = (value) => {
    value.idBox = null;
    value.boxDescription = null;
    value.boxCode = null;
    setInvoices([...invoice, value]);
    setSelectedItens(
      selectedItens.filter(
        (item) => item.posicaoPedVenda !== value.posicaoPedVenda
      )
    );
  };

  const addAllItem = () => {
    invoice.forEach((obj) => {
      obj.idBox = selectedBox.pkB_PK_idBox;
      obj.boxDescription = selectedBoxList.boxDescription;
      obj.boxCode = selectedBoxList.boxId;
    });
    setSelectedItens([...selectedItens, ...invoice]);
    setInvoices([]);
  };

  const removeAllItem = () => {
    selectedItens.forEach((obj) => {
      obj.idBox = null;
      obj.boxDescription = null;
      obj.boxCode = null;
    });

    setInvoices([...invoice, ...selectedItens]);
    setSelectedItens([]);
  };
  return (
    <>
      <Navbar />
      <Sidebar />
      <div
        className={`app_body ${getStatusSideBar()}`}
        style={{ backgroundColor: "white", height: "87vh" }}
      >
        <h2 className="title_tables text-center">
          {language[selectedCountry.name].DocumentosExercito.title}
        </h2>
        <div style={{ display: "flex", gap: 10 }}>
          <div style={{ width: "50%", height: "70vh" }}>
            <div style={{ height: "70vh", display: "flex" }}>
              <div className="w-100">
                <TextField
                  required
                  id="outlined-basic"
                  label="Código do Pedido"
                  variant="outlined"
                  fullWidth
                  className="mb-3"
                  value={order}
                  onChange={(event) => setOrder(event.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.keyCode === 13) getOrder();
                  }}
                  style={{ backgroundColor: "white", borderRadius: "5px" }}
                />
                <Paper
                  sx={{
                    width: "100%",
                    height: "85%",
                    overflowY: "scroll",
                    backgroundColor: "#e3e3e3",
                    padding: 0,
                  }}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ fontWeight: "bold" }}>
                          {language[selectedCountry.name].DocumentosExercito.tableHeader.posicao}
                        </TableCell>
                        <TableCell align="left" style={{ fontWeight: "bold" }}>
                          {language[selectedCountry.name].DocumentosExercito.tableHeader.peca}
                        </TableCell>
                        <TableCell align="left" style={{ fontWeight: "bold" }}>
                          {language[selectedCountry.name].DocumentosExercito.tableHeader.zfer}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {invoice.map((row) => (
                        <TableRow
                          key={row.packing}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                            "&:hover": {
                              backgroundColor: "#c0c0c0",
                              cursor: "pointer",
                            },
                            borderBottom: "1px solid gray",
                          }}
                          onClick={() => handleAddItem(row)}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            style={{ padding: 11 }}
                          >
                            {row.posicaoPedVenda}
                          </TableCell>
                          <TableCell align="left" style={{ padding: 11 }}>
                            {row.part_Description}
                          </TableCell>
                          <TableCell align="left" style={{ padding: 11 }}>
                            {row.material}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Paper>
              </div>
            </div>
          </div>

          <div style={{ width: 200, marginLeft: 10 }}>
            <FormControl fullWidth className="mb-3">
              <InputLabel id="demo-simple-select-label">Caixa</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedBox.pkB_BoxDescription}
                label="Caixa"
                size="small"
                onChange={handleChangeBox}
                style={{ backgroundColor: "white", borderRadius: "5px" }}
              >
                {!!Box &&
                  Object.entries(Box).map((item, index) => {
                    return (
                      <MenuItem
                        value={item[1]}
                        key={`Box-${index}`}
                      >
                        {item[1].pkB_BoxDescription}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#007aa2",
              }}
              onClick={addBox}
            >
              <p style={{ textAlign: "center", margin: "auto" }}></p>
              <p style={{ textAlign: "center", margin: "auto" }}>
                {language[selectedCountry.name].DocumentosExercito.btn.btnNovaCaixa}
              </p>
              <Add style={{ marginLeft: "auto" }} />
            </Button>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                marginTop: 40,
              }}
            >
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  justifyContent: "center",
                  marginBottom: 70,
                }}
              >
                <IconButton aria-label="delete">
                  <ArrowForwardIosIcon onClick={addAllItem} />
                </IconButton>
                <IconButton aria-label="delete" onClick={removeAllItem}>
                  <ArrowBackIosNewIcon />
                </IconButton>
              </div>
            </div>
          </div>
          <div style={{ width: "50%" }}>
            <Paper
              sx={{
                width: "100%",
                height: "25vh",
                overflowY: "scroll",
                backgroundColor: "#e3e3e3",
              }}
            >
              <List component="div" role="list">
                {boxList.map((value) => (
                  <ListItem
                    key={value.packing}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 10,
                      backgroundColor:
                        selectedBoxList === value ? "white" : "transparent",
                      borderBottom: "1px solid black",
                      "&:hover": {
                        backgroundColor:
                          selectedBoxList === value ? "white" : "#c0c0c0",
                        cursor: "pointer",
                      },
                    }}
                    role="listitem"
                    style={{ gap: 10 }}
                  >
                    <div onClick={() => setSelectedBoxList(value)}>
                      Caixa: {value.boxDescription} Código: {value.boxId}
                    </div>
                    <IconButton
                      onClick={() => removeBox(value)}
                      style={{ height: 0 }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </ListItem>
                ))}
              </List>
            </Paper>
            <Paper
              sx={{
                width: "100%",
                height: "41vh",
                overflowY: "scroll",
                backgroundColor: "#e3e3e3",
                marginTop: 1,
              }}
            >
              <Table size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                      {language[selectedCountry.name].DocumentosExercito.tableHeader.posicao}
                    </TableCell>
                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                      {language[selectedCountry.name].DocumentosExercito.tableHeader.peca}
                    </TableCell>
                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                      {language[selectedCountry.name].DocumentosExercito.tableHeader.zfer}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedItens
                    .filter((row) => row.boxCode === selectedBoxList.boxId)
                    .map((row) => (
                      <TableRow
                        key={row.packing}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          "&:hover": {
                            backgroundColor: "#c0c0c0",
                            cursor: "pointer",
                          },
                          padding: 0,
                        }}
                        onClick={() => handleRemoveItem(row)}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          style={{ padding: 4 }}
                        >
                          {row.posicaoPedVenda}
                        </TableCell>
                        <TableCell align="left" style={{}}>
                          {row.part_Description}
                        </TableCell>
                        <TableCell align="left" style={{}}>
                          {row.material}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </Paper>
          </div>
        </div>
        <div></div>
        <div></div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: 20,
            marginBottom: "10px",
          }}
        ></div>
        <div
          style={{ display: "flex", alignItems: "end", justifyContent: "end" }}
        >
          <Button
            variant="contained"
            style={{ marginRight: 10, backgroundColor: "#007aa2" }}
            onClick={sendOrders}
          >
            {language[selectedCountry.name].DocumentosExercito.btn.gerarDocumentos}
            <DescriptionIcon />
          </Button>
          <Button
            variant="contained"
            style={{ marginRight: 10, backgroundColor: "#007aa2" }}
            onClick={() => {
              navigate("/invoice/");
            }}
          >
            {language[selectedCountry.name].DocumentosExercito.btn.abrirDocumentos}
            <FolderOpenIcon />
          </Button>
        </div>
      </div>
    </>
  );
}
